import { render, staticRenderFns } from "./newBind.vue?vue&type=template&id=5bd1fe28&scoped=true"
import script from "./newBind.vue?vue&type=script&lang=js"
export * from "./newBind.vue?vue&type=script&lang=js"
import style0 from "./newBind.vue?vue&type=style&index=0&id=5bd1fe28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd1fe28",
  null
  
)

export default component.exports